<template>
    <header class="page-header">
        <div class="container">
            <div class="row1">
                <div class="img-contaier"><img src="../assets/img/logo01.png" alt="logo" /></div>
                <ul class="platform">
                    <li class="plate" @click='$router.push("/login2")'>远程教育平台</li>
                    <li class="separator"></li>
                    <li class="plate">家庭教育平台</li>
                    <li class="separator"></li>
                    <li class="plate">终生教育平台</li>
                </ul>
                <div class="search-bar">
                    <el-input @click="$router.push('/serch')" size="mini" placeholder="搜索" prefix-icon="el-icon-search" v-model="searchVal" disabled>
                    </el-input>
                </div>
            </div>
            <div class="row2">
                <div class="classes" v-if="false">
                    <div class="block-title">全部课程分类</div>
                    <div class="class-row" v-for="(item, index) in classList" :key="index" @click="$router.push(item.url)">
                        <div class="class-row-title">{{item.title}}</div>
                        <div class="class-item">
                            <span v-for="cItem in item.list">/ {{cItem}}</span>
                        </div>
                    </div>
                </div>
                <ul class="menu">
                    <li class="menu-item" :class="{'active': cur == `/index`}" @click="$router.push(`/index`)">首页</li>
                    <li class="menu-item" :class="{'active': cur == `/aboutUs`}" @click="$router.push(`/aboutUs`)">模式介绍</li>
                    <li class="menu-item" :class="{'active': cur == `/solution`}" @click="$router.push(`/solution`)">模式入园</li>
                    <li class="menu-item" :class="{'active': cur == `/teachers`}" @click="$router.push(`/teachers`)">技能提升</li>
                    <li class="menu-item" :class="{'active': cur == `/addclass`}" @click="$router.push(`/addclass`)">考试中心</li>
                    <li class="menu-item" :class="{'active': cur == `/shop`}" @click="$router.push(`/shop`)">官方商城</li>
                </ul>
                <div class="btns" v-if="!isLogin">
                    <div class="login" @click='$router.push("/login")'>登录</div>
                    <div class="register" @click='$router.push("/register")'>注册</div>
                </div>
                <div class="user-header" v-else>
                    <el-avatar size="medium" :src="$store.state.baseUrl+userInfo.userImg" style="margin-right: 4px;"></el-avatar>
                    <div class="">{{'个人中心'}}</div>
                    <!-- <div class="">{{userInfo.name}}</div> -->
                    <div class="drop-menu-container">
                        <div class="drop-menu">
                            <div class="user-info">
                                <el-avatar size="small" :src="$store.state.baseUrl+userInfo.userImg"></el-avatar>
                                <div class="user-info-detail">
                                    <div class="user-info-phone">{{userInfo.phone}}</div>
                                    <div class="user-info-id">ID: {{userInfo.id}}</div>
                                </div>
                            </div>
                            <div class="my-page" @click="$router.push('/personal')">我的个人主页</div>
                            <div class="logout-btn" @click="logout">退出登录</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    data() {
        return {
            searchVal: "",
            classList: [
                { title: this.$t("teacher.Package"), url: '/teachers?index=0', list: [
                    // '双语故事表演', '双语故事表演'
                ]},
                { title: this.$t("teacher.Multilingual"), url: '/teachers?index=1', list: [
                    // '人文素养', '自然科学'
                ]},
                { title: this.$t("teacher.game"), url: '/teachers?index=2', list: [
                    // '托福', '雅思', '四六级',
                ]},
                { title: this.$t("teacher.toy"), url: '/teachers?index=3', list: [
                    // '法语', '德语', '韩语'
                ]},
                { title: this.$t("teacher.openClass"), url: '/teachers?index=4', list: [
                    // '研究生留学', '博士生留学'
                ]},
                // { title: '大学考试' , url: '/teachers?index=0', list: [
                //     // '双语故事表演', '双语故事表演'
                // ]},
            ]
        }
    },
    computed: {
        cur() {
            // console.log(this.$route.path)
            return this.$route.path
        },
        isLogin() {
            return this.$store.state.isLogin
        },
        userInfo() {
            return this.$store.state.userInfo
        },
    },
    methods: {
        open(index, type) {
            if (this.hot === index) {
                return false;
            }
            const mapData = new Map([
                [0, "/index"],
                [1, "/teachers"],
                [2, "/addclass"],
                // [3, "/recruitIndex"],
                [3, "/aboutBase"],
                [4, "/aboutUs"],
            ]);
            const path = mapData.get(index);
            this.$router.push(path);
            // if (type) {
            // 	this.$router.push({
            // 		path: path,
            // 		params: {
            // 			type: type
            // 		}
            // 	});
            // } else {
            // 	this.$router.push(path);
            // }
            this.hot = index;
        },

        logout() {
            this.$message.success('退出登录')
            window.localStorage.removeItem('token', null)
            window.localStorage.removeItem('userInfo', null)
            window.localStorage.setItem('isLogin', false)
            this.$store.commit("changeLogin", false);
            this.$router.push('/login')
        },
    }
}
</script>

<style lang="less" scoped>
.page-header {
    height: 136px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 0 17px;
    // border: 1px solid red;
    // position: fixed;
    // z-index: 10;
    // left: 50%;
    // transform: translateX(-50%);
    background-color: #FFF;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1500);
    border-bottom: 1px solid #eee;
    .container{
        width: 1200px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 auto;
        position: relative;
    }
    .row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .img-contaier {
            width: 300px;
            height: 50px;
            position: relative;
            left: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 100%;
            }
            // position: absolute;
            // left: 70px;
            // top: 0;
        }

        .platform {
            display: flex;
            // justify-content: space-between;
            align-items: center;
            position: absolute;
            right: 230px;
            font-family: MicrosoftYaHei;
            color: #999999;

            .separator {
                font-size: 14px;
                height: 15px;
                margin: 0 21px;
                border-right: 1px solid #999;
            }

            .plate {
                cursor: pointer;
            }
        }

        .search-bar {
            width: 186px;
            height: 38px;
        }

    }

    .row2 {
        display: flex;
        justify-content: space-between;
        width: 100%;
        position: relative;
        padding-left: 305px;

        .classes {
            // display: none;
            width: 240px;
            // height: 378px;
            background: #FFFFFF;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2500);
            border-radius: 16px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;
            box-sizing: border-box;
            padding: 20px 30px 35px;
            .block-title{
                font-size: 20px;
                font-family: OPPOSans-B, OPPOSans;
                font-weight: normal;
                color: #0093DD;
                width: 100%;
                text-align: center;
                padding-bottom: 20px;
                border-bottom: 1px solid #eee;
                cursor: pointer
            }
            .class-row{
                margin-top: 22px;
                display: flex;
                .class-row-title{
                    cursor: pointer;
                    font-size: 16px;
                    font-family: OPPOSans-R, OPPOSans;
                    font-weight: normal;
                    color: #333333;
                    // width: 70px;
                    margin-right: 10px;
                }
                .class-item{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    // width: calc(100% - 80px);
                    span:hover{
                        color: #0093DD;
                        cursor: pointer;
                    }
                }
            }
        }

        .menu {
            display: flex;
            align-items: center;
            font-family: MicrosoftYaHei;

            .menu-item {
                font-size: 16px;
                margin-right: 48px;
                cursor: pointer;
                &:hover {
                    font-size: 16px;
                    color: #0093DD;
                }
            }
            .active {
                font-size: 16px;
                color: #0093DD;
            }
        }

        .btns {
            display: flex;

            div {
                width: 80px;
                height: 35px;
                border-radius: 8px;
                text-align: center;
                line-height: 35px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                cursor: pointer;
            }

            .login {
                background: #0093DD;
                color: #FFFFFF;
            }

            .register {
                margin-left: 10px;
                border: 1px solid #E8E8E8;
                color: #666666;
            }
        }
    }
    .user-header{
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        // border: 1px solid red;
        // padding-bottom: 10px;
        .header-icon{
            height: 36px;
            width: 36px;
            background: #0093DD;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            color: #FFF;
        }
        &:hover .drop-menu-container{
            display: block;
        }
        .drop-menu-container{
            display: none;
            position: absolute;
            bottom: -170px;
            z-index: 10;
            // border: 1px solid red;
            transform: translateX(-50%);
            padding-top: 10px;
        }
        .drop-menu{
            width: 210px;
            height: 160px;
            box-shadow: 0  2px 5px rgba(0, 0, 0, 0.4);

            border-radius: 8px;
            background-color: #FFF;
            box-sizing: border-box;
            padding: 11px 23px;
            .user-info{
                display: flex;
                align-items: center;
            }
            .user-info-detail{
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #666666;
                margin-left: 14px;
                .user-info-id{
                    margin-top: 5px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                }
            }
            .my-page{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-top: 22px;
                border-bottom: 1px solid #eee;
                padding-bottom: 18px;
                cursor: pointer;
            }
            .logout-btn{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-top: 9px;
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header-v2.vue